import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Leaf, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin/dashboard");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-forest-900 flex items-center justify-center p-6 grain">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md bg-sand rounded-3xl p-8 md:p-10 shadow-2xl"
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="h-11 w-11 rounded-full bg-forest-900 flex items-center justify-center text-sand"><Leaf size={20} /></div>
          <div>
            <div className="font-serif text-xl text-forest-900">Panel de Administración</div>
            <div className="text-xs text-forest-700/60">Oymer Vida Divina</div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-forest-800">Correo electrónico</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1.5 w-full rounded-xl border border-forest-900/15 bg-white px-4 py-3 text-forest-900 outline-none focus:border-terracotta-500 transition-colors"
              placeholder="admin@oymervidadivina.com"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-forest-800">Contraseña</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1.5 w-full rounded-xl border border-forest-900/15 bg-white px-4 py-3 text-forest-900 outline-none focus:border-terracotta-500 transition-colors"
              placeholder="••••••••"
            />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full rounded-xl bg-forest-900 text-sand py-3.5 font-semibold hover:bg-terracotta-500 transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading && <Loader2 size={18} className="animate-spin" />}
            Ingresar
          </button>
        </form>
      </motion.div>
    </div>
  );
}
